import mdlCommune from '@/models/General/GCommune'
import GCompany from '../../../models/General/GCompany'
import PostCustomerCreditOptions from '../../../models/POS/PosCustomerCreditOption'
import PchPaymentCondition from '../../../models/Purchase/PchPaymentCondition'

const initCompanyData = async ({ state, dispatch, rootGetters }) => {
    if (state.companyData) return
    if (localStorage.getItem('company-data'))
        dispatch(
            'setCompanyData',
            JSON.parse(localStorage.getItem('company-data'))
        )
    if (!rootGetters['AuthModule/isAuthenticated']) {
        setTimeout(() => dispatch('initCompanyData'), 200)
        return
    } else {
        new GCompany()
            .first()
            .then(r => {
                localStorage.setItem('company-data', JSON.stringify(r))
                dispatch('setCompanyData', r)
            })
            .catch(console.log)
    }
}

const setCompanyData = ({ commit }, data) => commit('SET_COMPANY_DATA', data)

const initCommunes = async ({ commit }) => {
    let communes = await mdlCommune.params({ get_all_results: true }).get()
    commit('SET_COMMUNES', communes.data)
}

const setIsTransbankIntegrated = ({ commit }, bool) =>
    commit('SET_IS_TRANSBANK_INTEGRATED', bool)
const setHtmlPrint = ({ commit }, bool) => commit('SET_HTML_PRINT', bool)

const setCustomerCreditOptions = ({ commit }, options) =>
    commit('SET_CUSTOMER_CREDIT_OPTIONS', options)

const fetchCustomerCreditOptions = ({ dispatch }) =>
    new PostCustomerCreditOptions()
        .include('days')
        .get()
        .then(r => dispatch('setCustomerCreditOptions', r.data))
        .catch(console.log)

const setPchPaymentConditions = ({ commit }, array) =>
    commit('SET_PCH_PAYMENT_CONDITIONS', array)

const fetchPchPaymentConditions = ({ dispatch }) =>
    new PchPaymentCondition()
        .include('days')
        .get()
        .then(r => dispatch('setPchPaymentConditions', r.data))
        .catch(console.log)

const transformPchPaymentConditionIdToCustomerCreditOptionId = (
    { state },
    id
) => {
    try {
        let pchDays = state.pchPaymentConditions.find(cond => cond.id === id)
            .days
        return state.customerCreditOptions.find(opt => opt.days === pchDays).id
    } catch (e) {
        return null
    }
}

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

export default {
    resetState,
    initCommunes,
    setIsTransbankIntegrated,
    initCompanyData,
    setCompanyData,
    setHtmlPrint,
    setCustomerCreditOptions,
    fetchCustomerCreditOptions,
    setPchPaymentConditions,
    fetchPchPaymentConditions,
    transformPchPaymentConditionIdToCustomerCreditOptionId,
}
